
import { Vue } from "vue-class-component";

export default class About extends Vue {

  async clearCache() {    
    const cacheKeys = await caches.keys();
    console.log('Cache keys found: ', cacheKeys);
    for(const cacheKey in cacheKeys) {
      console.log('Delete cache ' + cacheKey);
      const didDelete = await caches.delete(cacheKey);
      if (didDelete) {
        console.log('Failed to delete');
      } else {
        console.log('Cache key deleted');
      }
    }
    
    setTimeout(() => {
      window.location.reload(true);
    }, 1000);
  }
}
